// utils/notifySafe.js
export function isIOS() {
  try { return /iPhone|iPad|iPod/.test(navigator.userAgent); } catch { return false; }
}
export function isStandalone() {
  try {
    const mm = typeof window !== "undefined" && window.matchMedia
      ? window.matchMedia("(display-mode: standalone)")
      : null;
    return (mm && mm.matches) || (typeof navigator !== "undefined" && navigator.standalone === true);
  } catch { return false; }
}
export function hasNotificationAPI() {
  return typeof window !== "undefined" && typeof window.Notification !== "undefined";
}
export function canUseWebPushHere() {
  // iOS requires PWA; other platforms allow in-tab
  if (isIOS()) return isStandalone() && hasNotificationAPI();
  return hasNotificationAPI();
}

// Safe wrapper for showing a native notification when available
export function showNativeNotification(title, options) {
  if (!canUseWebPushHere()) return false;
  try {
    if (window.Notification.permission === "granted") {
      new window.Notification(title, options);
      return true;
    }
  } catch {}
  return false;
}
